<template>
  <div class="version-tag">
    <v-chip pill :color="chipColor" class="mr-5" small>
      <v-icon id="version_tag__version__icon" :color="iconColor" left small>{{ icon.branch }}</v-icon>
      <span id="version_tag__version__label" :class="textColor">v{{ appVersion }} RI</span>
    </v-chip>
  </div>
</template>

<script>
import { mdiSourceBranch } from '@mdi/js'
import { appThemeData } from '@/store/helpers'

export default {
  name: 'VersionTag',
  data() {
    return {
      icon: {
        branch: mdiSourceBranch
      }
    }
  },
  props: {
    darkMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...appThemeData,
    appVersion: {
      get() {
        return process.env.VUE_APP_VERSION
      }
    },
    textColor: {
      get() {
        if (this.darkMode) {
          return 'white--text'
        }

        return 'teal--text'
      }
    },
    iconColor: {
      get() {
        if (this.darkMode) {
          return 'rgba(245,245,245,1)'
        }

        return this.appThemeComponentsMainColor
      }
    },
    chipColor: {
      get() {
        if (this.darkMode) {
          return this.appThemeComponentsMainColor
        }

        return 'rgba(245,245,245,1)'
      }
    }
  }
}
</script>
